(function () {
  const root = document.querySelector('[data-vnd-product-media]');
  if (!root) return;

  const thumbs = Array.from(root.querySelectorAll('[data-vnd-media-thumb]'));
  const mainVideo = root.querySelector('[data-vnd-media-main-video]');
  const mainPhotoTrigger = root.querySelector('[data-vnd-media-main-photo-trigger]');
  const mainImage = root.querySelector('[data-vnd-media-main-image]');
  const previousButton = root.querySelector('[data-vnd-media-prev]');
  const nextButton = root.querySelector('[data-vnd-media-next]');
  const lightbox = root.querySelector('[data-vnd-media-lightbox]');
  const total = thumbs.length;
  if (!total || !mainVideo || !mainPhotoTrigger || !mainImage) return;

  const wrap = (index, length) => ((index % length) + length) % length;
  const photoEntries = thumbs
    .filter((thumb) => thumb.dataset.vndMediaType === 'photo')
    .map((thumb) => ({
      mediaIndex: Number(thumb.dataset.vndMediaIndex) || 0,
      src: thumb.dataset.vndMediaSrc || thumb.getAttribute('href') || '',
      alt: thumb.dataset.vndMediaAlt || '',
      caption: thumb.dataset.vndMediaCaption || ''
    }))
    .filter((photo) => photo.src);
  let current = Math.max(0, thumbs.findIndex((thumb) => thumb.classList.contains('is-selected')));
  if (current < 0) current = 0;
  root.classList.add('is-enhanced');

  const select = (index, options = {}) => {
    current = wrap(Number.isFinite(Number(index)) ? Number(index) : 0, total);
    const isVideo = current === 0;
    root.classList.toggle('is-showing-video', isVideo);
    if (isVideo) {
      mainVideo.hidden = false;
      mainVideo.setAttribute('aria-hidden', 'false');
      mainPhotoTrigger.hidden = true;
    } else {
      const photo = photoEntries.find((entry) => entry.mediaIndex === current) || photoEntries[wrap(current - 1, photoEntries.length)];
      if (!photo) return;
      mainVideo.hidden = true;
      mainVideo.setAttribute('aria-hidden', 'true');
      mainVideo.pause();
      try { mainVideo.currentTime = 0; } catch (error) { /* read-only media stream */ }
      mainImage.src = photo.src;
      mainImage.alt = photo.alt;
      mainPhotoTrigger.href = photo.src;
      mainPhotoTrigger.dataset.vndMediaSrc = photo.src;
      mainPhotoTrigger.dataset.vndMediaAlt = photo.alt;
      mainPhotoTrigger.dataset.vndMediaCaption = photo.caption;
      mainPhotoTrigger.setAttribute('aria-label', 'View ' + photo.alt + ' full size');
      mainPhotoTrigger.hidden = false;
    }
    thumbs.forEach((thumb) => {
      const selected = Number(thumb.dataset.vndMediaIndex) === current;
      thumb.classList.toggle('is-selected', selected);
      thumb.setAttribute('aria-pressed', String(selected));
      thumb.setAttribute('aria-current', selected ? 'true' : 'false');
    });
    root.dataset.vndMediaIndex = String(current);
    const selectedThumb = thumbs[current];
    if (selectedThumb && options.scroll !== false) selectedThumb.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    if (options.focus) {
      const target = isVideo ? mainVideo : mainPhotoTrigger;
      target.focus({ preventScroll: true });
    }
  };

  thumbs.forEach((thumb) => {
    const choose = () => select(Number(thumb.dataset.vndMediaIndex) || 0);
    thumb.addEventListener('pointerenter', choose);
    thumb.addEventListener('focusin', choose);
    thumb.addEventListener('click', (event) => {
      event.preventDefault();
      choose();
    });
  });
  if (previousButton) previousButton.addEventListener('click', () => select(current - 1));
  if (nextButton) nextButton.addEventListener('click', () => select(current + 1));
  document.addEventListener('keydown', (event) => {
    if (!root.contains(document.activeElement)) return;
    if (lightbox && !lightbox.hidden) return;
    if (event.target instanceof Element && event.target.closest('video, input, textarea, select')) return;
    if (event.key === 'ArrowLeft') { event.preventDefault(); select(current - 1); }
    if (event.key === 'ArrowRight') { event.preventDefault(); select(current + 1); }
  });
  select(current, { scroll: false });

  if (!lightbox || !photoEntries.length) return;
  const lightboxImage = lightbox.querySelector('[data-vnd-media-lightbox-image]');
  const lightboxCaption = lightbox.querySelector('[data-vnd-media-lightbox-caption]');
  const lightboxTitle = lightbox.querySelector('[data-vnd-media-lightbox-title]');
  const closeButton = lightbox.querySelector('[data-vnd-media-lightbox-close]');
  const backdrop = lightbox.querySelector('[data-vnd-media-lightbox-backdrop]');
  const lightboxPrevious = lightbox.querySelector('[data-vnd-media-lightbox-prev]');
  const lightboxNext = lightbox.querySelector('[data-vnd-media-lightbox-next]');
  const zoomIn = lightbox.querySelector('[data-vnd-media-lightbox-zoom-in]');
  const zoomOut = lightbox.querySelector('[data-vnd-media-lightbox-zoom-out]');
  const zoomReset = lightbox.querySelector('[data-vnd-media-lightbox-zoom-reset]');
  if (!lightboxImage || !closeButton || !backdrop) return;

  const minZoom = 0.75;
  const maxZoom = 3;
  const zoomStep = 0.25;
  let currentPhoto = 0;
  let zoomScale = 1;
  let lastFocused = null;

  const applyZoom = () => {
    lightboxImage.style.transform = 'scale(' + zoomScale + ')';
    if (zoomReset) zoomReset.textContent = Math.round(zoomScale * 100) + '%';
    if (zoomIn) zoomIn.disabled = zoomScale >= maxZoom;
    if (zoomOut) zoomOut.disabled = zoomScale <= minZoom;
  };
  const setZoom = (value) => {
    zoomScale = Math.max(minZoom, Math.min(maxZoom, Math.round(value * 100) / 100));
    applyZoom();
  };
  const render = (index, syncMain) => {
    currentPhoto = wrap(index, photoEntries.length);
    const photo = photoEntries[currentPhoto];
    if (syncMain) select(photo.mediaIndex, { scroll: false });
    lightboxImage.src = photo.src;
    lightboxImage.alt = photo.alt;
    if (lightboxCaption) lightboxCaption.textContent = photo.caption;
    if (lightboxTitle) lightboxTitle.textContent = 'Ryndal product photo ' + (currentPhoto + 1) + ' of ' + photoEntries.length;
    setZoom(1);
    if (lightboxPrevious) lightboxPrevious.disabled = photoEntries.length < 2;
    if (lightboxNext) lightboxNext.disabled = photoEntries.length < 2;
  };
  const open = () => {
    const src = mainPhotoTrigger.dataset.vndMediaSrc;
    const index = photoEntries.findIndex((photo) => photo.src === src);
    if (index < 0) return;
    lastFocused = document.activeElement;
    render(index, true);
    lightbox.hidden = false;
    lightbox.setAttribute('aria-hidden', 'false');
    document.body.classList.add('vnd-media-lightbox-open');
    closeButton.focus();
  };
  const close = () => {
    lightbox.hidden = true;
    lightbox.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('vnd-media-lightbox-open');
    lightboxImage.removeAttribute('src');
    lightboxImage.style.transform = '';
    if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
  };
  const focusable = () => Array.from(lightbox.querySelectorAll('button, a[href], [tabindex]:not([tabindex="-1"])'))
    .filter((node) => !node.disabled && node.getClientRects().length > 0);
  mainPhotoTrigger.addEventListener('click', (event) => { event.preventDefault(); open(); });
  if (zoomIn) zoomIn.addEventListener('click', () => setZoom(zoomScale + zoomStep));
  if (zoomOut) zoomOut.addEventListener('click', () => setZoom(zoomScale - zoomStep));
  if (zoomReset) zoomReset.addEventListener('click', () => setZoom(1));
  closeButton.addEventListener('click', close);
  backdrop.addEventListener('click', close);
  if (lightboxPrevious) lightboxPrevious.addEventListener('click', () => render(currentPhoto - 1, true));
  if (lightboxNext) lightboxNext.addEventListener('click', () => render(currentPhoto + 1, true));
  lightbox.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') { event.preventDefault(); close(); return; }
    if (event.key === 'ArrowLeft') { event.preventDefault(); render(currentPhoto - 1, true); return; }
    if (event.key === 'ArrowRight') { event.preventDefault(); render(currentPhoto + 1, true); return; }
    if (event.key === '+' || event.key === '=') { event.preventDefault(); setZoom(zoomScale + zoomStep); return; }
    if (event.key === '-') { event.preventDefault(); setZoom(zoomScale - zoomStep); return; }
    if (event.key === '0') { event.preventDefault(); setZoom(1); return; }
    if (event.key !== 'Tab') return;
    const nodes = focusable();
    if (!nodes.length) return;
    const first = nodes[0];
    const last = nodes[nodes.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  });
})();

(function () {
  const drawer = document.querySelector('[data-drawer]');
  const backdrop = document.querySelector('[data-drawer-backdrop]');
  const openButton = document.querySelector('[data-drawer-open]');
  const closeButton = document.querySelector('[data-drawer-close]');
  if (!drawer || !backdrop || !openButton || !closeButton) return;
  let lastFocused = null;
  const focusable = () => drawer.querySelectorAll('a, button, [tabindex]:not([tabindex="-1"])');
  const setOpen = (open) => {
    drawer.classList.toggle('is-open', open);
    drawer.setAttribute('aria-hidden', String(!open));
    drawer.inert = !open;
    openButton.setAttribute('aria-expanded', String(open));
    backdrop.hidden = !open;
    document.body.classList.toggle('drawer-open', open);
    if (open) {
      lastFocused = document.activeElement;
      closeButton.focus();
    } else if (lastFocused) {
      lastFocused.focus();
    }
  };
  drawer.inert = true;
  openButton.addEventListener('click', () => setOpen(true));
  closeButton.addEventListener('click', () => setOpen(false));
  backdrop.addEventListener('click', () => setOpen(false));
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && drawer.classList.contains('is-open')) setOpen(false);
    if (event.key !== 'Tab' || !drawer.classList.contains('is-open')) return;
    const nodes = Array.from(focusable());
    if (!nodes.length) return;
    const first = nodes[0]; const last = nodes[nodes.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  });
})();

(function () {
  const gallery = document.querySelector('[data-vnd-product-gallery]');
  if (!gallery) return;
  const slides = Array.from(gallery.querySelectorAll('[data-vnd-gallery-slide]'));
  const previous = gallery.querySelector('[data-vnd-gallery-prev]');
  const next = gallery.querySelector('[data-vnd-gallery-next]');
  const status = gallery.querySelector('[data-vnd-gallery-status]');
  if (slides.length < 3 || !previous || !next || !status) return;
  let current = slides.findIndex((slide) => slide.classList.contains('is-active'));
  if (current < 0) current = 0;
  let hoverLocked = false;
  let hoverBounds = null;
  const wrap = (index) => (index + slides.length) % slides.length;
  const select = (index, focus) => {
    current = wrap(index);
    const previousIndex = wrap(current - 1);
    const nextIndex = wrap(current + 1);
    slides.forEach((slide, indexValue) => {
      const isPrevious = indexValue === previousIndex;
      const isActive = indexValue === current;
      const isNext = indexValue === nextIndex;
      slide.classList.toggle('is-prev', isPrevious);
      slide.classList.toggle('is-active', isActive);
      slide.classList.toggle('is-next', isNext);
      slide.setAttribute('aria-hidden', String(!isPrevious && !isActive && !isNext));
      slide.setAttribute('aria-pressed', String(isActive));
      slide.tabIndex = isPrevious || isActive || isNext ? 0 : -1;
    });
    status.textContent = `Image ${current + 1} of ${slides.length}`;
    if (focus) slides[current].focus({ preventScroll: true });
  };
  const selectFromSlide = (slide, focus) => select(Number(slide.dataset.vndGalleryIndex), focus);
  slides.forEach((slide) => {
    slide.addEventListener('pointerenter', () => {
      if (hoverLocked) return;
      if (slide.classList.contains('is-prev') || slide.classList.contains('is-next')) {
        hoverLocked = true;
        hoverBounds = slide.getBoundingClientRect();
        selectFromSlide(slide, false);
      }
    });
    slide.addEventListener('click', () => selectFromSlide(slide, true));
  });
  gallery.addEventListener('pointermove', (event) => {
    if (!hoverLocked || !hoverBounds) return;
    const outside = event.clientX < hoverBounds.left ||
      event.clientX > hoverBounds.right ||
      event.clientY < hoverBounds.top ||
      event.clientY > hoverBounds.bottom;
    if (outside) {
      hoverLocked = false;
      hoverBounds = null;
    }
  });
  gallery.addEventListener('pointerleave', () => {
    hoverLocked = false;
    hoverBounds = null;
  });
  previous.addEventListener('click', () => select(current - 1, true));
  next.addEventListener('click', () => select(current + 1, true));
  gallery.addEventListener('keydown', (event) => {
    if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
    event.preventDefault();
    select(current + (event.key === 'ArrowRight' ? 1 : -1), true);
  });
  select(current, false);
})();

(function () {
  const dialog = document.querySelector('[data-vnd-age-confirmation]');
  const confirmButton = dialog?.querySelector('[data-age-confirm]');
  const leaveButton = dialog?.querySelector('[data-age-leave]');
  const state = window.vndAgeState;
  if (!dialog || !confirmButton || !leaveButton || !state) return;
  const html = document.documentElement;
  const background = [...document.body.children].filter(node => node !== dialog && node.tagName !== 'SCRIPT');
  const priorInert = new Map(background.map(node => [node, node.inert]));
  let open = false;
  let exited = false;
  const setOpen = value => {
    open = value;
    dialog.hidden = !value;
    html.dataset.vndAge = value ? 'pending' : 'confirmed';
    document.body.classList.toggle('vnd-age-locked', value);
    background.forEach(node => { node.inert = value ? true : priorInert.get(node); });
    if (value) confirmButton.focus();
  };
  confirmButton.addEventListener('click', () => {
    state.confirm();
    setOpen(false);
    document.getElementById('MainContent')?.focus();
    window.dispatchEvent(new CustomEvent('vnd:age-confirmed'));
  });
  leaveButton.addEventListener('click', () => {
    exited = true;
    state.clear();
    const screen = document.createElement('main');
    screen.tabIndex = -1;
    screen.setAttribute('aria-label', 'Site closed');
    screen.textContent = 'You have left this site. You can close this tab.';
    screen.style.cssText = 'position:fixed;inset:0;display:grid;place-items:center;padding:24px;background:#fff;color:#222;font:16px/1.5 Arial,sans-serif;visibility:visible';
    html.dataset.vndAge = 'exited';
    screen.setAttribute('data-vnd-age-confirmation', '');
    document.body.classList.remove('vnd-age-locked');
    document.body.replaceChildren(screen);
    open = false;
    screen.focus();
  });
  document.addEventListener('keydown', (event) => {
    if (!open) return;
    if (event.key === 'Escape') { event.preventDefault(); leaveButton.focus(); return; }
    if (event.key !== 'Tab') return;
    const nodes = [...dialog.querySelectorAll('button,a[href],input,[tabindex]:not([tabindex="-1"])')]
      .filter(node => !node.disabled && node.getClientRects().length > 0);
    const first = nodes[0]; const last = nodes[nodes.length - 1];
    if (!first) return;
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  });
  window.addEventListener('pageshow', event => { if (!exited && event.persisted) setOpen(!state.read()); });
  window.addEventListener('storage', event => { if (!exited && event.key === state.key) setOpen(!state.read()); });
  setOpen(!state.read());
})();


